
export const SITE_NAME = "Top Line Ads";
export const SITE_URL = "https://www.toplineadsportal.com/";
export const BANNER_SITE_URL = "https://ruuban.com/";
